import React from 'react';
import { useCountryContext } from '../../context';
import ErrorFeature from '../../components/error-feature';
import Layout from '@scentregroup/shared/hub-components/layout';
import { jsx as _jsx } from "react/jsx-runtime";
const Error = _ref => {
  let {
    error,
    status,
    headerStaticData
  } = _ref;
  const country = useCountryContext();
  return /*#__PURE__*/_jsx(Layout, {
    country: country,
    header: {
      variant: 'national',
      data: headerStaticData
    },
    "data-id": "error_index_Error_Layout",
    children: /*#__PURE__*/_jsx(ErrorFeature, {
      error: error,
      status: status,
      "data-id": "error_index_Error_Layout_ErrorFeature"
    })
  });
};
Error.defaultProps = {
  status: 404
};
export default Error;